import axios from "axios";
import './core.scss'
// import './loading/Loading.scss'

import Loading from "./loading/Loading.tsx";

const baseURL = process.env.REACT_APP_BASE_URL;
const axiosServise = axios.create({
    baseURL: baseURL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});
let root = document.documentElement;
axiosServise.interceptors.request.use(function (config) {
    // document.body.classList.add('loading-indicator');

    root.style.setProperty('--visibility', 'visible');
    console.log('loading')

    return config
}, function (error) {
    root.style.setProperty('--visibility', 'collapse');
    console.log('failLoad')
    return Promise.reject(error);
});

axiosServise.interceptors.response.use(
    function (response) {
        // document.body.classList.remove('loading-indicator');
        root.style.setProperty('--visibility', 'collapse');
        console.log('loaded')
        return response;
    },
    function (error) {
        console.log('failLoad')
        root.style.setProperty('--visibility', 'collapse');
        let res = error.response;
        if (res?.status === 401) {
        }
        return Promise.reject(error);
    }
);
export default axiosServise;
